import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"summary-item pa-6 my-2"},[_c('router-link',{attrs:{"to":{ name: _vm.target }}},[(_vm.editable)?_c(VIcon,{staticClass:"icon"},[_vm._v("mdi-pencil")]):_vm._e()],1),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }